import { Entity, FilterDefinition, FilterSections } from '../types';

export type FilterProps = {
  definition: FilterDefinition;
  values?: Entity[];
  disabled: boolean;
  onChange: (name: string, values: Entity[]) => void;
};

export type SectionWithDefinitions = [FilterSections, FilterDefinition[]];

export enum CustomTrayInfo {
  feature = 'feature',
  price = 'price',
  label = 'label',
}

export enum CustomSegmentType {
  customPriceClass = 'custom-price',
  customFeatureSegmentation = 'custom-segmentation',
}
